import { render } from "./EditDewar.vue?vue&type=template&id=2caca635&scoped=true"
import script from "./EditDewar.vue?vue&type=script&lang=js"
export * from "./EditDewar.vue?vue&type=script&lang=js"

import "./EditDewar.vue?vue&type=style&index=0&id=2caca635&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2caca635"]])

export default __exports__